import { render, staticRenderFns } from "./RightChart2.vue?vue&type=template&id=2fd2425e&scoped=true&"
import script from "./RightChart2.vue?vue&type=script&lang=js&"
export * from "./RightChart2.vue?vue&type=script&lang=js&"
import style0 from "./RightChart2.vue?vue&type=style&index=0&id=2fd2425e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2425e",
  null
  
)

export default component.exports